import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "blueFilterIndicatorsGroup" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_filter_indikator_group_price_range = _resolveComponent("filter-indikator-group-price-range");
    const _component_filter_indikator_group_universal = _resolveComponent("filter-indikator-group-universal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_filter_indikator_group_price_range),
        _createVNode(_component_filter_indikator_group_universal, {
            "filter-type": _ctx.BlueFilterType.CONDITIONS
        }, null, 8, ["filter-type"]),
        _createVNode(_component_filter_indikator_group_universal, {
            "filter-type": _ctx.BlueFilterType.BRANDS
        }, null, 8, ["filter-type"])
    ]));
}
